<template>
    <div class='dataApi_wrap'>
        <iframe id="bdIframe" width="100%" frameborder="1" border="0" src="https://cqipc.mssdk.vip/source/doc/#/" height="100%" ></iframe>
    </div>
</template>

<script>
export default {
    data () {
        return {}
    },
    created(){},
    methods:{}
}
</script> 

<style lang='scss' scoped>
.dataApi_wrap{
    width: 100%;
    height: calc(100vh + 70px);
    text-align: center;
}
#bdIframe{
    // margin-top: 70px;
    width: 100%;
}
</style>